import { useState } from "react"
import { colorIsValid, colorWithHash } from "utilities/colors"

/** A hex field's text: what's typed, until the color changes elsewhere (undo, the selection). */
const useHexDraft = (color: string) => {
  const [draft, setDraft] = useState<{ text: string, color: string } | null>(null)

  const text = draft && draft.color === color ? draft.text : colorWithHash(color)

  const type = (input: string) => {
    const typed = colorIsValid(input) ? colorWithHash(input) : null
    setDraft({ text: input, color: typed ?? color })

    return typed
  }

  return { text, type }
}

export default useHexDraft
